import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../context/SettingsContext";

function OrganicProductCard() {
  const { t, i18n } = useTranslation();
  const settings = useSettings();
  const isBn = i18n.language === "bn";

  const titleSpecial = isBn 
    ? (settings.organic_title_special_bn || t("organicProduct.titleSpecial", "100% Natural Quality"))
    : (settings.organic_title_special_en || t("organicProduct.titleSpecial", "100% Natural Quality"));

  const titleRest = isBn 
    ? (settings.organic_title_rest_bn || t("organicProduct.titleRest", "Organic Product"))
    : (settings.organic_title_rest_en || t("organicProduct.titleRest", "Organic Product"));

  const desc = isBn 
    ? (settings.organic_desc_bn || t("organicProduct.desc", "See Our latest discounted products from here and get a special"))
    : (settings.organic_desc_en || t("organicProduct.desc", "See Our latest discounted products from here and get a special"));

  const linkText = isBn 
    ? (settings.organic_link_text_bn || t("organicProduct.discountLink", "discount product"))
    : (settings.organic_link_text_en || t("organicProduct.discountLink", "discount product"));

  const btnText = isBn 
    ? (settings.organic_btn_text_bn || t("shopNow", "Shop Now"))
    : (settings.organic_btn_text_en || t("shopNow", "Shop Now"));

  return (
    <div className="bg-orange-100 px-10 py-6 rounded-lg mt-6 hidden lg:block">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl">
            <span className="text-emerald-600 font-bold">
              {titleSpecial}{" "}
            </span>
            {titleRest}
          </h1>
          <p className="text-gray-500">
            {desc}{" "}
            <Link
              className="ml-1 !no-underline !text-emerald-600"
              to="/#discount"
            >
              {linkText}
            </Link>
          </p>
        </div>
        <Link
          className="flex justify-center items-center text-sm font-serif font-medium px-6 h-9  !bg-emerald-500 text-center rounded-full !text-white !no-underline hover:!bg-emerald-700"
          to="/shop"
        >
          {btnText}
        </Link>
      </div>
    </div>
  );
}

export default OrganicProductCard;
